<template>
  <div class="homePage">
    <v-container>
      <div class="controlPanel">Betmakers<br> Control Panel</div>
    </v-container>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.homePage {
  background: lightblue url("../assets/homeBack.jpeg") no-repeat fixed center;
  height:95vh;
  width:100%
}
.controlPanel {
  font-size:5rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin:0 auto;
  top:40%;
  position:absolute;
  font-weight: 900;
  color:#fff;
}
</style>